const customGallery = [
  { src: "/images/custom/customDesk1.jpg", alt: "Custom Juniper Desk" },
  { src: "/images/custom/customDesk2.jpg", alt: "Custom Juniper Desk" },
  { src: "/images/custom/customDesk3.jpg", alt: "Custom Juniper Desk" },
  { src: "/images/custom/customCons1.jpg", alt: "Custom Console" },
  { src: "/images/custom/customCons2.jpg", alt: "Custom Console" },
  { src: "/images/custom/customCons3.jpg", alt: "Custom Console" },
  { src: "/images/custom/customCons4.jpeg", alt: "Custom Console" },
  { src: "/images/custom/customCons5.jpeg", alt: "Custom Console" },
  { src: "/images/custom/customCons6.jpeg", alt: "Custom Console" },
  { src: "/images/custom/customCons7.jpeg", alt: "Custom Console" },
  { src: "/images/custom/customCons8.jpeg", alt: "Custom Console" },
  { src: "/images/custom/customDiningSet.jpeg", alt: "Custom Dining Set" },
  
];

export default customGallery;